import React, {Component} from 'react';
import './css/PersonObituary.styl';
import {connect} from 'react-redux';
import moment from 'moment';
import {buildObitFlowersUrl} from '../../../../../shared/utilities/urlHelpers';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';
import getForestLawnFuneralHomeIds from '../../../../../../data/ForestLawnFuneralHomeIds';
import SocialButtons from '../../Shared/SocialButtons';

export class PersonObituary extends Component {
  getPublishDate() {
    const start = moment
      .utc(this.props.personObit.publishedStartDate)
      .format('MMM DD, YYYY');
    const end = moment
      .utc(this.props.personObit.publishedCompleteDate)
      .format('MMM DD, YYYY');

    if (start === end) {
      return end;
    }

    return `${moment
      .utc(this.props.personObit.publishedStartDate)
      .format('MMM DD')} to ${end}`;
  }

  truncateStringByWordCount = (str, no_words) =>
    str
      .split(' ')
      .splice(0, no_words)
      .join(' ');

  formatDescription(descriptionHtml, maxWordLength) {
    const fullDescription = descriptionHtml.replace(/<(?:.|\n)*?>/gm, '');
    const truncatedDescription = this.truncateStringByWordCount(
      fullDescription,
      maxWordLength
    );

    return fullDescription.split(/\W+/).length > maxWordLength
      ? `${truncatedDescription}... `
      : fullDescription;
  }

  handleNameClick = () => {
    getGATags({
      eventCategory: 'fhd_obit',
      eventAction: 'obit_name_click',
      eventLabel: 'fhd_obit_name',
    });
  };

  handleImageClick = () => {
    getGATags({
      eventCategory: 'fhd_obit',
      eventAction: 'obit_image_click',
      eventLabel: 'fhd_obit_image',
    });
  };

  handleReadMoreClick = () => {
    getGATags({
      eventCategory: 'fhd_obit',
      eventAction: 'obit_readmore_click',
      eventLabel: 'fhd_obit_read_more',
    });
  };

  render() {
    const {
      obituaryId,
      imageUrl,
      fullName,
      lifespan,
      descriptionHtml,
      obituaryUrl,
      publishedType,
      publisherDisplayName,
      maxWordLength = 40,
      ampUrl
    } = this.props.personObit;
    const {affiliateId, funeralHome, isMobile} = this.props;
    const {name, location, flowerSettings, funeralHomeId} = funeralHome;
    const flowersUrlOptions = {
      personId: obituaryId,
      personName: fullName,
      affiliateId,
      cultureCode: location.country.cultureCode,
      flowerSettings,
      isMobile,
    };

    const socialUrls = {
      flowersUrl: buildObitFlowersUrl(flowersUrlOptions),
      obituaryUrl,
    };

    const socialDetails = {
      fullName,
      isPlanning: this.props.isPlanning,
    };

    const formattedDescription = this.formatDescription(
      descriptionHtml,
      maxWordLength
    );
    const formattedLifespan = lifespan ? `(${lifespan})` : '';
    const ForestLawnFuneralHomeIds = getForestLawnFuneralHomeIds();
    const IsForestLawnFuneralHome = ForestLawnFuneralHomeIds.includes(funeralHomeId);
    const IsNotTribues = publisherDisplayName !== 'Tributes.com';

    return (
      <div className="person-obituary" data-id={obituaryId}>
        <div className="person-content">
          <div className="person-content__header">
            <div className="person-content__name-lifespan">
              <a onClick={this.handleNameClick} href={(isMobile && !IsForestLawnFuneralHome && IsNotTribues) ? ampUrl : obituaryUrl}>
                {fullName} {formattedLifespan}
              </a>
            </div>
            <div
              onClick={this.handleImageClick}
              className="person-content__picture"
              style={{backgroundImage: `url(${imageUrl})`}}
            />
          </div>
          <div className="description">
            {formattedDescription}
            <a
              href={(isMobile && !IsForestLawnFuneralHome && IsNotTribues) ? ampUrl : obituaryUrl}
              onClick={this.handleReadMoreClick}
              style={{marginLeft: '0.5rem'}}
            >
              Read More
            </a>
          </div>
          {['Tributes.com', 'Batesville', 'Dignity Memorial'].includes(
            publisherDisplayName
          ) ? (
              <div className="publisher">
                Published {publishedType} on {this.getPublishDate()} courtesy of{' '}
                {name}.
            </div>
            ) : (
              <div className="publisher">
                Published {publishedType} in {publisherDisplayName}{' '}
                {this.getPublishDate()}
              </div>
            )}
          <SocialButtons
            type="obituary"
            urls={socialUrls}
            details={socialDetails}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isPlanning: state.planningStore.isPlanning,
  affiliateId: state.affiliateStore.sourceId,
  funeralHome: state.funeralHomeStore,
  isMobile: state.mobileDetailsStore.any,
});

export default connect(mapStateToProps)(PersonObituary);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/Obituaries/personObituary.js